import {
  GET_CLUB_MEMBERSHIP_SUCCESS,
  CLUB_MEMBERSHIP_REQUESTING,
  LIST_CLUB_MEMBERSHIPS_SUCCESS,
  RESET_CLUB_MEMBERSHIP_ISFETCHING,
  RESET_CLUB_MEMBERSHIP_QUERY
} from './constants';

const INITIAL_STATE = {
  data: null,
  isFetching: false,
  newMembership: null,
  query: null,
  recordCount: null
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_CLUB_MEMBERSHIP_ISFETCHING: {
      return {
        ...state,
        isFetching: false
      };
    }
    case RESET_CLUB_MEMBERSHIP_QUERY: {
      return {
        ...state,
        query: null,
        recordCount: null
      };
    }
    case CLUB_MEMBERSHIP_REQUESTING: {
      return {
        ...state,
        isFetching: true
      };
    }
    case LIST_CLUB_MEMBERSHIPS_SUCCESS: {
      const data = { ...state.data };
      const query = [];
      action.payload.clubMemberships.forEach((object) => {
        data[object.id] = object;
        query.push(object.id);
      });
      return {
        ...state,
        data,
        query,
        recordCount: action.payload.total,
        isFetching: false
      };
    }
    case GET_CLUB_MEMBERSHIP_SUCCESS: {
      const data = { ...state.data };
      data[action.payload.id] = action.payload;
      return {
        ...state,
        data,
        isFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;

export const getActiveClubMemberships = (clubMembership) => {
  if (!clubMembership.data) {
    return null;
  }
  const clubMembershipIds = Object.keys(clubMembership.data);
  const activeIds = clubMembershipIds.filter(
    (id) => clubMembership.data[id].status === 'Active'
  );
  return activeIds.map((id) => clubMembership.data[id]);
};

export const getHoldClubMemberships = (clubMembership) => {
  if (!clubMembership.data) {
    return null;
  }
  const clubMembershipIds = Object.keys(clubMembership.data);
  const activeIds = clubMembershipIds.filter(
    (id) => clubMembership.data[id].status === 'On Hold'
  );
  return activeIds.map((id) => clubMembership.data[id]);
};

export const getCancelledClubMemberships = (clubMembership) => {
  if (!clubMembership.data) {
    return null;
  }
  const clubMembershipIds = Object.keys(clubMembership.data);
  const activeIds = clubMembershipIds.filter(
    (id) => clubMembership.data[id].status === 'Cancelled'
  );
  return activeIds.map((id) => clubMembership.data[id]);
};
